import { useBoolean } from '@chakra-ui/react'
import { createContext, FC } from 'react'

import { ILayoutContext } from '@base/@types/providers/Shared/LayoutProvider'

const LayoutProvider: FC = ({ children }) => {
  const [menuToggle, setMenuToggle] = useBoolean(false)

  return (
    <LayoutContext.Provider
      value={{
        menuToggle,
        setMenuToggle
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export default LayoutProvider
export const LayoutContext = createContext<ILayoutContext>({} as ILayoutContext)
